import { ref, computed, onMounted, onUnmounted } from 'vue'
import { api } from '../services/api.js'

export function useDashboardData() {
  const data = ref(null)
  const loading = ref(false)
  const error = ref(null)
  const selectedDevelopment = ref('')
  const allDevelopments = ref([])
  let refreshInterval = null

  const developments = computed(() => {
    if (allDevelopments.value.length > 0) return allDevelopments.value
    if (!data.value || !data.value.development_health) return []
    const names = new Set(
      data.value.development_health.map(item => item.development)
    )
    return Array.from(names).sort()
  })

  const updateAllDevelopments = () => {
    if (!data.value || !data.value.development_health) return
    const names = new Set(data.value.development_health.map(item => item.development))
    allDevelopments.value = Array.from(names).sort()
  }

  const fetchData = async () => {
    loading.value = true
    error.value = null
    try {
      const params = {}
      if (selectedDevelopment.value) {
        params.development = selectedDevelopment.value
      }
      const response = await api.get('/dashboard/', { params })
      data.value = response.data
      if (!selectedDevelopment.value) {
        updateAllDevelopments()
      }
    } catch (err) {
      error.value = err.message || 'Failed to fetch dashboard data'
      console.error('Dashboard fetch error:', err)
    } finally {
      loading.value = false
    }
  }

  const setDevelopment = (development) => {
    selectedDevelopment.value = development
    fetchData()
  }

  const startAutoRefresh = (intervalMs = 300000) => {
    stopAutoRefresh()
    refreshInterval = setInterval(fetchData, intervalMs)
  }

  const stopAutoRefresh = () => {
    if (refreshInterval) {
      clearInterval(refreshInterval)
      refreshInterval = null
    }
  }

  onMounted(() => {
    fetchData()
    startAutoRefresh()
  })

  onUnmounted(() => {
    stopAutoRefresh()
  })

  return {
    data,
    loading,
    error,
    selectedDevelopment,
    developments,
    fetchData,
    setDevelopment,
    startAutoRefresh,
    stopAutoRefresh,
  }
}
